export enum NewItemRevisionStatusModes {
    Reset = 1,
    Keep = 2,
    Ask = 3,
}